import { useMutation, useQueryClient } from '@tanstack/react-query'
import type { ISpProfilePublic, PatchSpDemographicsInput } from '@brushfire/types'
import { apiClient } from '@/api/http/client'
import type { ApiResponse } from '@/api/http/types'
import { queryKeys } from '@/api/query-keys'
import { runDetached } from '@/shared/lib/runDetachedPromise'

export function usePatchSpDemographics() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (input: PatchSpDemographicsInput) => {
      const { data } = await apiClient.patch<ApiResponse<ISpProfilePublic>>(
        '/api/v1/sp/profile/demographics',
        input,
      )
      return data.data
    },
    onSuccess: () => {
      runDetached(qc.invalidateQueries({ queryKey: queryKeys.spProfile.detail() }))
      runDetached(qc.invalidateQueries({ queryKey: queryKeys.spProfile.completeness() }))
    },
  })
}
